/** @typedef {Object} SimaElectronicSignature
 * @property {boolean} enabled
 */

/** @typedef {Object} FeaturesState
 * @property {SimaElectronicSignature} simaElectronicSignature
 */

class FeaturesConfig {
  /** @typedef FeaturesState */
  _state;

  constructor(ctx) {
    this.ctx = ctx;
  }

  /** @returns {FeaturesState} */
  get state() {
    return this._state;
  }

  get isSimaEnabled() {
    return Boolean(
      this.state && this.state.simaElectronicSignature && this.state.simaElectronicSignature.enabled
    );
  }

  set state(value) {
    this._state = value;
  }

  async init() {
    const { data, success } = await this.ctx.$api.dispatch('features/getStates');

    if (!success) {
      return this.ctx.$sentry.captureException(new Error('Failed to get feature states'));
    }

    this.state = data;
  }
}

export default async (ctx, inject) => {
  ctx.$api.register('features', '/web/private/client', request => ({
    getStates() {
      return request('GET', '/features/states');
    },
  }));

  const features = new FeaturesConfig(ctx);

  if (ctx.$auth.loggedIn) {
    await features.init();
  }

  ctx.$features = features;
  inject('features', features);
};
